import React from 'react'
import {
  Icon,
  Message,
  Popup
} from 'semantic-ui-react'
// Local
import { REVIEW, shouldRenderReskin2025 } from '../../../constant'
import { withOutstandingQuery } from '../../common/conditionUtils'
import ConditionQueryStatusIcon from './conditionQueryStatusIcon'
import {
  EncounterConditionDisplay,
  EncounterReview
} from '../../authenticated/types'
import If from '../../common/if'
import ReveleerCoachingBox from '../../ReveleerCoachingBox'

/**
 * Provides a component that renders the encounter Coder QA message
 * @param review Encounter review entity
 * @param conditions Encounter conditions
 * @param mode Render mode. Default: left
 */

type Props = {
  review: EncounterReview | null | undefined
  conditions: EncounterConditionDisplay[]
  mode?: string | undefined
}

type InfoMessageProps = {
  review: EncounterReview | null | undefined
  queryOutstanding: EncounterConditionDisplay[]
  isReviewQueryOutstanding: boolean
}

function InfoMessage(
  props: InfoMessageProps
): JSX.Element {
  const {
    review,
    queryOutstanding,
    isReviewQueryOutstanding
  } = props
  return (
    <>
      <div className="bold">
        Coder Patient Review
      </div>
      <If isTrue={ !!review && review.reviewCode === REVIEW.CODE.READY_FOR_CODER_QA }>
        <div>
          Ready for Coder QA
        </div>
      </If>
      <If isTrue={ !!review && review.reviewCode === REVIEW.CODE.COMPLETED }>
        <div>
          Completed
        </div>
      </If>
      <If isTrue={ queryOutstanding && queryOutstanding.length > 0 }>
        <div>
          <ConditionQueryStatusIcon
            condition={ queryOutstanding[0] }
            popup="One or More Conditions with Outstanding Queries"
          />
          <span>
            &nbsp;
          </span>
          <span>
            Outstanding Query
          </span>
        </div>
      </If>
      <If isTrue={ isReviewQueryOutstanding }>
        <div>
          <Popup content="Coder Review Requested"
            trigger={
              <Icon
                name="hourglass half"
                color="black"
              />
            }
          />
          <span>
            &nbsp;
          </span>
          <span>
            Coder Review Requested
          </span>
        </div>
      </If>
    </>
  )
}

function EncounterCoderQa(
  props: Props
): JSX.Element | null {
  const {
    review,
    conditions,
    mode = 'left'
  } = props


  if (mode === 'left' && review) {
    const queryOutstanding = withOutstandingQuery(conditions)
    const isReviewQueryOutstanding = review.queryStatusCode === REVIEW.QUERY_STATUS.REVIEW_QUERY_OUTSTANDING
    return (
      <div>
        <If isTrue={ !shouldRenderReskin2025 }>
          <Message
            warning
            className="cdi"
          >
            <InfoMessage
              review={ review }
              queryOutstanding={ queryOutstanding }
              isReviewQueryOutstanding={ isReviewQueryOutstanding }
            />
          </Message>
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <ReveleerCoachingBox
            coachingBoxType="infoNegative"
            isShowing
            message={
              <InfoMessage
                review={ review }
                queryOutstanding={ queryOutstanding }
                isReviewQueryOutstanding={ isReviewQueryOutstanding }
              />

            }
          />
        </If>
      </div>
    )
  }
  return null
}

export default EncounterCoderQa
